module.exports = __webpack_public_path__ + "3e080e929f9c64fa9ac61e9d4ef4bbf0.jpg";